import React from 'react';

import { useIntl } from 'react-intl';

import { cssMap } from '@atlaskit/css';
import { fg } from '@atlaskit/platform-feature-flags';
import { Box, Flex, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { JiraAppSelectorIcon } from './jira-app-selector';
import { messages } from './messages';

const styles = cssMap({
	moreButtonStyles: {
		alignItems: 'center',
		backgroundColor: token('color.background.neutral'),
		borderRadius: token('radius.small'),
		display: 'flex',
		marginLeft: token('space.050'),
		paddingLeft: token('space.050'),
		paddingRight: token('space.050'),
	},
	moreButtonStylesOld: {
		alignItems: 'center',
		backgroundColor: token('elevation.surface.sunken'),
		border: `${token('border.width')} solid ${token('color.border.inverse')}`,
		borderRadius: token('radius.small'),
		display: 'flex',
		paddingLeft: token('space.100'),
		paddingRight: token('space.075'),
	},
	iconsStylesOld: {
		display: 'flex',
		translate: token('space.025'),
	},
});

type Props = {
	appCount?: number;
	/**
	 * Optional custom icon content to render instead of the default static JiraAppSelectorIcon.
	 * When provided and search_all_apps_icon_app_count feature gate is on, this replaces the hardcoded icon strip.
	 */
	icon?: React.ReactNode;
};

export const AllAppsIcon = ({ appCount, icon }: Props): React.JSX.Element => {
	const { formatMessage } = useIntl();

	if (fg('search_all_apps_icon_app_count')) {
		const label =
			appCount !== undefined && appCount > 0
				? formatMessage(messages.moreWithCount, { appCount })
				: formatMessage(messages.more);

		return (
			<Flex role="presentation" alignItems="center">
				{icon ?? <JiraAppSelectorIcon />}

				<Box xcss={styles.moreButtonStyles}>
					<Text size="small" align="center" color="color.text.subtle">
						{label}
					</Text>
				</Box>
			</Flex>
		);
	}

	return (
		<Flex role="presentation" alignItems="center">
			<Box xcss={styles.iconsStylesOld}>
				<JiraAppSelectorIcon />
			</Box>

			<Box xcss={styles.moreButtonStylesOld}>
				<Text size="small" align="center" color="color.text.subtle">
					{formatMessage(messages.more)}
				</Text>
			</Box>
		</Flex>
	);
};
